import { Injectable } from '@angular/core';
import { DatabaseGwService } from '../database-gw.service';

@Injectable({
  providedIn: 'root'
})
export class AccountingClassService extends DatabaseGwService{

  URL_PATH: string = '/acc-classes';
}
